// extracted by mini-css-extract-plugin
export default {"mainContainer":"CreatePost_mainContainer__T-qed","textArea":"CreatePost_textArea__o0NYy","public":"CreatePost_public__s4t87"};